var map = {
	"./logo-airtable.svg": 807196,
	"./logo-apple.svg": 135021,
	"./logo-discord.svg": 487470,
	"./logo-figma.svg": 125408,
	"./logo-google-doc.svg": 297651,
	"./logo-google-form.svg": 588736,
	"./logo-google.svg": 687278,
	"./logo-miro.svg": 11989,
	"./logo-scorm.svg": 544563,
	"./logo-slack.svg": 2851,
	"./logo-typeform.svg": 8991,
	"./logo-typeformdark.svg": 768979,
	"./logo-whereby.svg": 905330,
	"./logo-wistia.svg": 934664,
	"core/ui/disco/icons/color-logo/logo-airtable.svg": 807196,
	"core/ui/disco/icons/color-logo/logo-apple.svg": 135021,
	"core/ui/disco/icons/color-logo/logo-discord.svg": 487470,
	"core/ui/disco/icons/color-logo/logo-figma.svg": 125408,
	"core/ui/disco/icons/color-logo/logo-google-doc.svg": 297651,
	"core/ui/disco/icons/color-logo/logo-google-form.svg": 588736,
	"core/ui/disco/icons/color-logo/logo-google.svg": 687278,
	"core/ui/disco/icons/color-logo/logo-miro.svg": 11989,
	"core/ui/disco/icons/color-logo/logo-scorm.svg": 544563,
	"core/ui/disco/icons/color-logo/logo-slack.svg": 2851,
	"core/ui/disco/icons/color-logo/logo-typeform.svg": 8991,
	"core/ui/disco/icons/color-logo/logo-typeformdark.svg": 768979,
	"core/ui/disco/icons/color-logo/logo-whereby.svg": 905330,
	"core/ui/disco/icons/color-logo/logo-wistia.svg": 934664
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 637132;